import styles from './OrderNumber.module.scss';

import { orderStore } from '@/entities/order/store/orderStore';
import { restaurantStore } from '@/entities/restaurant/store/restaurantStore';
import { imageLink } from '@/shared/lib';
import { observer } from '@/shared/lib/signal/observer';
import { Modal } from '@/shared/ui-kit/Modal/Modal';

interface OrderNumberProps {
  open: boolean;
  onClose: () => void;
}

export const OrderNumber: React.FC<OrderNumberProps> = observer(
  ({ open, onClose }: OrderNumberProps) => {
    const title = restaurantStore.current.value?.name ?? '';
    const lastOrder = orderStore.orderStatusModalSelectedOrder.value;
    const orderCode = lastOrder?.shortCode ?? lastOrder?.id ?? '';
    const logoSrc = imageLink(restaurantStore.current.value?.image);

    return (
      <Modal
        open={open}
        onClose={onClose}
        title={title}
        className={styles.modal}
        logoSrc={logoSrc}
      >
        <div className={styles.container}>
          <h1 className={styles.title}>{orderCode}</h1>
          <h2 className={styles.subtitle}>номер заказа</h2>
        </div>
      </Modal>
    );
  }
);
